import * as React from 'react';

import { noop } from '@utils/noop';

import { IProductItemProps } from './model';
import { StyledProductCard } from './styled';
import { useProductItemProps } from './useGetProductItemProps';

export const ProductItem: React.FC<IProductItemProps> = React.memo(
  ({
    columns,
    innerRef,
    onProductAdded = noop,
    onProductAddFailed = noop,
    onClosingCartModal = noop,
    setProductWishlisted,
    sendGTM = false,
    useMasterUrl = false,
    showBuyButton = false,
    showWishlistButton = true,
    position = 0,
    appendComponent = null,
    showAddToCartModal = true,
    canSpaRedirect = true,
    ...rest
  }) => {
    const productProps = useProductItemProps({
      useMasterUrl,
      sendGTM,
      canSpaRedirect,
      setProductWishlisted,
      onProductAdded,
      onProductAddFailed,
      onClosingCartModal,
      showBuyButton,
      showWishlistButton,
      showAddToCartModal,
      position,
      appendComponent,
      ...rest,
    });

    if (!productProps) {
      return null;
    }

    return (
      <StyledProductCard
        data-testid="product-item"
        columns={columns}
        ref={innerRef as React.Ref<HTMLDivElement>}
        data-cypress="productItem-container"
        productProps={productProps}
      />
    );
  }
);

export default ProductItem;
